import { render, staticRenderFns } from "./InternalRefUserForm.vue?vue&type=template&id=056dee33&"
import script from "./InternalRefUserForm.vue?vue&type=script&lang=ts&"
export * from "./InternalRefUserForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports